import React, { Suspense, useEffect, useState } from "react";
import { Form, Icon, List, Message } from "semantic-ui-react";
import { getSemanticProps } from "../../util";
import { getUiOptions } from "../../../../utils/getUiOptions";
import { useSchemaTranslation } from "../../../../hooks/useSchemaTranslation";
import { IHprOptions, IPerson, useHprContext, PeoplePicker } from "../../../../../sg-hpr";
import { makeSuccess, TResult } from "../../../../../sg-core";

interface PersonLabelProps {
  fetchPerson: IHprOptions["fetchPersonById"];
  personId: IPerson["id"];
  person?: IPerson;
  requiredCerts?: Array<string>;
}
const PersonLabel: React.FC<PersonLabelProps> = ({ personId, person: loadedPerson, fetchPerson, requiredCerts }) => {
  const [person, setPerson] = useState<TResult<IPerson> | undefined>(loadedPerson ? makeSuccess(loadedPerson) : undefined);

  useEffect(() => {
    const load = async () => {
      const result = await fetchPerson(personId);
      setPerson(result)
    }
    load()
  }, [personId]);


  return (
    <List.Item>
      {requiredCerts ? <Icon name="circle" color="red" /> : null}
      {
        person?.isFailure ? "Failed to fetch person"
          : person?.isSuccess ? person.value.fullname : ""
      }
    </List.Item>
  )
}

interface IPeoplePickerOptions {
  requiredCerts?: string[],
  [key: string]: any
}

function PersonPickerWidget({
  id,
  required,
  readonly,
  disabled,
  name,
  label,
  schema,
  value,
  onChange,
  onBlur,
  onFocus,
  autofocus,
  options,
  formContext,
  uiSchema = {},
  rawErrors = [],
}: any) {
  const hprContext = useHprContext()
  const { t } = useSchemaTranslation();

  const isMulti = schema.type === "array";

  const { placeholder } = getUiOptions(uiSchema);
  const { requiredCerts } = options || {};

  const semanticProps = getSemanticProps({ formContext, options });
  // eslint-disable-next-line no-shadow
  const _onChange = (value: any) => {
    onChange(value);
  }


  if (!hprContext) {
    return (
      <Message content="Missing HPR configurations" />
    )
  };


  const renderPersonLabel = (personId: IPerson["id"]) => (
    <PersonLabel personId={personId} fetchPerson={hprContext.fetchPersonById} requiredCerts={requiredCerts} />
  );

  const renderSearchResult = (person: IPerson) => (
    <PersonLabel personId={person.id} person={person} fetchPerson={hprContext.fetchPersonById} requiredCerts={requiredCerts} />
  );



  return (
    <Form.Field required={required} disabled={readonly || disabled}>
      {label && <label> {t(label)} </label>}
      <Suspense fallback={<div></div>}>
        <PeoplePicker
          onSearchPerson={hprContext.searchPerson}
          placeholder={placeholder}
          renderPersonLabel={renderPersonLabel}
          renderSearchResult={renderSearchResult}
          onChange={_onChange}
          isMulti={isMulti}
          value={value}
          requiredCerts={Array.isArray(requiredCerts) ? requiredCerts : []}
        />
      </Suspense>
    </Form.Field>

  );
}

export default PersonPickerWidget;
